import FacebookIcon from '@mui/icons-material/Facebook';
import GitHubIcon from '@mui/icons-material/GitHub';
import InfoIcon from '@mui/icons-material/Info';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PersonIcon from '@mui/icons-material/Person';
import PinterestIcon from '@mui/icons-material/Pinterest';
import RedditIcon from '@mui/icons-material/Reddit';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Button, Card, CardActions, CardContent, CardMedia, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Paper, Typography } from "@mui/material";
import Parser from 'html-react-parser';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PushPinIcon from '@mui/icons-material/PushPin';
import { newspinActions } from "../actions/newspin.actions";
import { NewsPinClass } from "../models/NewsPin";
import { DraggableSignInPopup } from "./SpaceItem";

import { makeStyles } from "@material-ui/core/styles";
import $ from 'jquery';
import Draggable from 'react-draggable';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Thumbnail from "./Thumbnail";

// Import Swiper React components
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

// import required modules
import { Autoplay, EffectFade, Pagination } from "swiper/modules";




export const Account = (props) => {
  var { socialmedia, link, logo, description } = props.data;
  const t = useSelector(state => state.themeswitch);
  const [theme, setTheme] = useState(t);

  function removePngExtension(filename) {
    if (filename.endsWith('.png')) {
      return filename.slice(0, -4);
    }
    return filename;
  }

  logo = removePngExtension(logo) + "-new.png"

  useEffect(() => {
    setTheme(t);
  }, [t])

  return (
    <>
      <Card sx={{ maxWidth: 350, marginBottom: 3 }}>
        <CardMedia
          component="img"
          alt="default avatar"
          height="350"
          image={logo}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            <a target="_blank" style={{ color: "#0D1F2D", textDecoration: "none" }} href={link}>{socialmedia === "Twitter" ? "X / Twitter" : socialmedia}</a>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <p style={{ color: '#000' }} >{description}</p>
          </Typography>
        </CardContent>
        <CardActions>
          <Button variant="contained" size="small" onClick={() => { window.open(link, "_blank"); }}>Go to Profil</Button>
        </CardActions>
      </Card>
    </>
  );
}

export const SocialMedia = (props) => {
  const { id, name, description, website } = props.data;
  return (
    <>
      <h3><a target="_blank" style={{ color: "#fff", textDecoration: "none" }} href={website}>{name}</a></h3>
      <div class="overflow-auto" style={{ maxHeight: 280 }}>
        <small style={{ display: "none" }}>{id}</small>
        <p class="marginItem" style={{ marginRight: "100px" }}>{description}</p>
      </div>
    </>
  );
}

export const SocialMediaNews = ({ index, data }) => {
  const { id, name, description, website, news, timeago, kind } = data;
  // kind is only set on cards coming from /mycontainers: "PLATFORM" for the 20
  // built-ins, "THEME" for a user's own card. Cards rendered straight from
  // /service/news (every anonymous visitor) have no kind at all, so isTheme is
  // false and every branch below behaves exactly as it did before.
  const isTheme = kind === "THEME";
  const identifier = "window_" + index;
  const identifierButton = "button_" + index;
  const [layout, setLayout] = useState(1);
  const qs = useSelector(state => state.quoteswitch);
  const [quoteswitch, setQuoteSwitch] = useState(qs);
  const t = useSelector(state => state.themeswitch);
  const [theme, setTheme] = useState(t);
  const [activeScroll, setActiveScroll] = useState(false);

  const handleLayoutChange = (e) => {
    e.preventDefault();
    if (layout === 1) {
      setLayout(2);
    } else if (layout === 2) {
      setLayout(1);
    }
  }

  useEffect(() => {
    setLayout(layout);
  }, [layout])

  useEffect(() => {
    localStorage.setItem("quote", qs)
    setQuoteSwitch(qs);
  }, [qs]);

  useEffect(() => {
    setTheme(t);
  }, [t])

  const makeScrollable = (e) => {
    setLayout(1);
    const index = e.target.id.split("_")[1];
    const window = "window_" + index;
    if (!activeScroll /*&& document.getElementById(window).style.overflow === "hidden"*/) {
      // document.getElementById(window).style.overflowY = "auto";
      // document.getElementById(e.target.id).innerText = "See Less";
      setActiveScroll(true);
    } else {
      // document.getElementById(window).style.overflowY = "hidden";
      // document.getElementById(e.target.id).innerText = "See More";
      setActiveScroll(false);
      $(window).scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }

  const displayImage = () => setTimeout(() => {
    setLayout(1);
  }, 10000);

  useEffect(() => {
    // Layout 3 is the image-only layout, and Image has no asset for a
    // user-created theme, so a theme card would periodically blank itself into
    // an empty box. This interval is the only thing that ever sets layout 3
    // (handleLayoutChange above only toggles 1 <-> 2), so skipping it keeps a
    // theme card on its news list permanently.
    if (isTheme) {
      return;
    }
    var identifier = "window_" + index;
    const interval = setInterval(() => {
      if (getRandomNumber(1, 100) >= 93 && getRandomNumber(1, 100) <= 100) {
        // Only layout 1 renders the identifier + "t" node, so on layouts 2
        // and 3 this lookup legitimately comes back null and reading .style
        // off it threw. No node means nothing to switch away from.
        const scrollable = document.getElementById(identifier + "t");
        if (scrollable && scrollable.style.overflowY !== "auto") {
          setLayout(3);
          displayImage();
        }
      }
    }, 5000);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [isTheme])

  // Belt and braces alongside the skipped interval above and the suppressed
  // InfoIcon below: a theme card can never render the image layout (3) or the
  // description layout (2) - both are empty for a theme - so it falls back to
  // its news list instead. With the icon gone, handleLayoutChange has no
  // caller on a theme card, which makes layout 2 unreachable already; this
  // keeps the branches honest if another caller ever appears.
  const effectiveLayout = isTheme && (layout === 2 || layout === 3) ? 1 : layout;

  if (effectiveLayout === 1) {
    return (
      <>
        <div id={identifier} style={{ backgroundColor: theme === 'dark' ? "#002147" : "#F7F9F9", borderRadius: 20, maxWidth: 350, overflowX: "hidden", overflowY: "hidden", paddingBottom: 10 }} >
          {/* The InfoIcon is not an info popup, it is the layout toggle into
              layout 2, which renders nothing but {description}. A theme has no
              description by design (the backend sends ""), so the toggle would
              turn the card into a blank box. The control has no other purpose
              for a theme, so it is not rendered at all rather than left dead. */}
          <h3 style={{ maxWidth: 350, borderTopLeftRadius: "20px 20px", margin: 0 }} class="p-3 bg-primary bg-gradient text-white draggable"><CardTitle name={name} website={website} kind={kind} /> <Logo name={name} kind={kind} />{isTheme ? <></> : <InfoIcon className="notDraggable" onClick={e => handleLayoutChange(e)} style={{ float: "right", marginTop: 5, cursor: "pointer" }} />}</h3>
          <div id={identifier + "t"} style={{ backgroundColor: theme === 'dark' ? "#002147" : "#F7F9F9", maxHeight: 500, maxWidth: 350, overflowX: "hidden", overflowY: activeScroll ? "auto" : "hidden", paddingLeft: 8 }} class="itemHeightMobil">
            <small style={{ display: "none" }}>{id}</small>
            {news.length !== 0 ?
              news.map((d) => (
                <p class="marginItem" style={{ marginBottom: 5, marginTop: 5, marginRight: 8, display: "flex", alignItems: "center" }}><span style={{ flex: 1, minWidth: 0 }}><span class="bg-primary bg-gradient text-white" style={{ padding: 2, borderRadius: 5 }} ><b>{d.timeago}</b></span>{"  "}<ArticleLink data={d} quoteswitch={quoteswitch} /></span><NewsSaveButton data={d} source={name} buttonStyle={{ marginLeft: 10 }} /></p>
              )) :
              <p class="marginItem" style={{ marginBottom: "0" }}>Updating...</p>
            }
          </div>
          <div style={{ backgroundColor: theme === 'dark' ? "#002147" : "#F7F9F9", maxWidth: 350, borderBottomLeftRadius: "20px 20px", borderBottomRightRadius: "20px 20px", padding: 10 }}>
            {news.length > 2 ?
              <Button id={identifierButton + "t"} style={{ marginLeft: 6, marginTop: 5, borderRadius: 20 }} onClick={makeScrollable} variant="contained">
                {activeScroll ? "See Less" : "See More"}
              </Button> :
              <></>
            }
          </div>
        </div>
      </>
    );
  } else if (effectiveLayout === 2) {
    return (
      <>
        <h3 style={{ maxHeight: 250, maxWidth: 350, borderRadius: 20 }} class="p-3 mb-2 bg-primary bg-gradient text-white"><CardTitle name={name} website={website} kind={kind} /> <Logo name={name} kind={kind} /><InfoIcon onClick={e => handleLayoutChange(e)} style={{ float: "right", marginTop: 5, cursor: "pointer" }} /></h3>
        <div style={{ maxHeight: 250, maxWidth: 350, overflowX: "hidden", overflowY: "auto", marginLeft: 8 }}>
          <small style={{ display: "none" }}>{id}</small>
          <p class="marginItem">{description}</p>
        </div>
      </>
    );
  } else if (effectiveLayout === 3) {
    return (
      <>
        <h3 style={{ maxWidth: 350, borderRadius: 20 }} class="p-3 mb-2 bg-primary bg-gradient text-white"><CardTitle name={name} website={website} kind={kind} /> <Logo name={name} kind={kind} /><InfoIcon onClick={e => handleLayoutChange(e)} style={{ float: "right", marginTop: 5, cursor: "pointer" }} /></h3>
        <div id={identifier} style={{ backgroundColor: theme === 'dark' ? "#0D1F2D" : "#F7F9F9", borderRadius: 8, maxHeight: 250, maxWidth: 345, overflowX: "hidden", overflowY: "hidden", marginLeft: 5 }} class="itemHeightMobil">
          <small style={{ display: "none" }}>{id}</small>
          <Image name={name} setLayout={setLayout} theme={theme} />
        </div>
        {news.length > 2 ?
          <Button id={identifierButton} style={{ marginLeft: 6, marginTop: 10, borderRadius: 20 }} onClick={makeScrollable} variant="contained">
            See More
          </Button> :
          <></>
        }
      </>
    );
  }

}

export const SocialMediaNewsPreview = ({ index, data }) => {
  const { id, name, description, website, news, timeago, linkspreview, kind } = data;
  // See the note on SocialMediaNews: absent for cards straight from
  // /service/news, so isTheme is false on every anonymous render.
  const isTheme = kind === "THEME";
  const identifier = "window_" + index;
  const identifierButton = "button_" + index;
  const [layout, setLayout] = useState(1);
  const qs = useSelector(state => state.quoteswitch);
  const [quoteswitch, setQuoteSwitch] = useState(qs);
  const pw = useSelector(state => state.previewswitch);
  const [previewswitch, setPreviewSwitch] = useState(pw);
  const t = useSelector(state => state.themeswitch);
  const [theme, setTheme] = useState(t);
  const [activeScroll, setActiveScroll] = useState(false);

  const handleLayoutChange = (e) => {
    e.preventDefault();
    if (layout === 1) {
      setLayout(3);
    } else if (layout === 3) {
      setLayout(1);
    }
  }

  useEffect(() => {
    setLayout(layout);
  }, [layout])

  useEffect(() => {
    localStorage.setItem("quote", qs)
    setQuoteSwitch(qs);
  }, [qs]);

  useEffect(() => {
    setPreviewSwitch(pw);
  }, [pw]);

  useEffect(() => {
    setTheme(t);
  }, [t])

  const makeScrollable = (e) => {
    if (layout === 1 || layout === 4) {
      setLayout(2);
    } else if (layout === 2) {
      setLayout(1);
    }
  }

  const makeScrollableForText = (e) => {
    setLayout(1);
    const index = e.target.id.split("_")[1];
    const window = "window_" + index;
    if (!activeScroll /*&& document.getElementById(window).style.overflow === "hidden"*/) {
      // document.getElementById(window).style.overflowY = "auto";
      setActiveScroll(true);
      // document.getElementById(e.target.id).innerText = "See Less";
    } else {
      // document.getElementById(window).style.overflowY = "hidden";
      setActiveScroll(false);
      // document.getElementById(e.target.id).innerText = "See More";
      $(window).scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }

  /* const displayImage = () => setTimeout(() => {
      setLayout(1);
    }, 10000);
  
    useEffect(() => {
      var identifier = "window_" + index;
      const interval = setInterval(() => {
      var rNummer = getRandomNumber(1, 100);
      if (rNummer >= 95 && rNummer <= 100 && document.getElementById(identifier + "t").style.overflowY !== "auto") {
        setLayout(3);
        displayImage();
      }
    }, 5000);
  
      return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }, []) 
  */

  // Layout 4 is the image-only layout and Image has no asset for a
  // user-created theme; layout 3 is the description-only layout and a theme
  // has no description. Neither is ever rendered for a theme - it falls back
  // to its news list. (Nothing currently sets layout 4 at all: the interval
  // that used to is the commented-out block above. Layout 3 was only ever
  // reachable through handleLayoutChange, whose single caller - the InfoIcon -
  // is no longer rendered on a theme card. Both branches stay guarded in case
  // another caller appears. Layout 2 is the expanded news list and stays
  // reachable: it is real content for a theme.)
  const effectiveLayout = isTheme && (layout === 3 || layout === 4) ? 1 : layout;

  if (effectiveLayout === 1) {
    // var autoplayTime = window.innerWidth >= 960 ? 15000 : 60000;
    var autoplayTime = 5000;

    return (
      <div id={identifier} style={{ backgroundColor: theme === 'dark' ? "#002147" : "#F7F9F9", borderRadius: 20, maxWidth: 350, overflowX: "hidden", overflowY: "hidden", paddingBottom: 10 }} >
        {/* Same as SocialMediaNews: the InfoIcon is the layout toggle, here
            into layout 3, which renders nothing but {description}. A theme has
            no description by design, so the control is not rendered at all. */}
        <h3 style={{ maxWidth: 350, borderTopLeftRadius: "20px 20px", margin: 0 }} class="p-3 bg-primary bg-gradient text-white draggable"><CardTitle name={name} website={website} kind={kind} /> <Logo name={name} kind={kind} />{isTheme ? <></> : <InfoIcon onClick={e => handleLayoutChange(e)} className="notDraggable" style={{ float: "right", marginTop: 5, cursor: "pointer" }} />}</h3>
        <Swiper
          centeredSlides={true}
          loop={true}
          autoHeight={true}
          effect={"fade"}
          autoplay={{
            delay: autoplayTime,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={false}
          modules={[Autoplay, Pagination, EffectFade]}
          className="mySwiper"
        >
          {linkspreview && linkspreview.length !== 0 ?
            linkspreview.map((d, idx) => {
              // linkspreview items lack publishedat/type, so merge the
              // matching news entry (by url) over it for NewsSaveButton.
              const matchingNews = news ? news.find(n => n.url === d.url) : undefined;
              const slideData = matchingNews ? { ...d, ...matchingNews } : d;

              return (
                <SwiperSlide key={d.url || idx}>
                  <div>
                    <PreviewSlideImage src={d.image} fallback="/newspaper.jpg" alt={d.title} />
                    <p class="px-3 pt-3 pb-4 bg-primary bg-gradient text-white" style={{ margin: 0, width: "100%", background: "#166fe5", textAlign: "left", color: '#fff', opacity: 1, display: "flex", alignItems: "center" }}><span style={{ flex: 1, minWidth: 0 }}><span class="bg-primary bg-gradient text-white" style={{ margin: 0, padding: 2, borderRadius: 5 }} ><b>{d.timeago}</b></span>{" "}<ArticleLink data={d} quoteswitch={quoteswitch} previewswitch={previewswitch} /></span><NewsSaveButton data={slideData} source={name} buttonStyle={{ marginLeft: 10 }} /></p>
                  </div>
                </SwiperSlide>);
            }) :
            news && news.length === 0 ?
              <>
                {/* No platform asset exists for a user-created theme, so a
                    theme with no articles yet shows only "Updating...". */}
                {isTheme ? <></> : <Image name={name} theme={theme} />}
                <p class="p-3 bg-primary bg-gradient text-white" style={{ marginBottom: "0", borderBottomLeftRadius: "20px 20px", borderBottomRightRadius: "20px 20px" }}>Updating...</p>
              </>
              :
              <>
                <div id={identifier + "t"} style={{ backgroundColor: theme === 'dark' ? "#002147" : "#F7F9F9", maxHeight: 500, maxWidth: 350, overflowX: "hidden", overflowY: activeScroll ? "auto" : "hidden", paddingLeft: 8 }} class="itemHeightMobil">
                  <small style={{ display: "none" }}>{id}</small>
                  {news.length !== 0 ?
                    news.map((d) => (
                      <p class="marginItem" style={{ marginBottom: 5, marginTop: 5, marginRight: 8, display: "flex", alignItems: "center" }}><span style={{ flex: 1, minWidth: 0 }}><span class="bg-primary bg-gradient text-white" style={{ padding: 2, borderRadius: 5 }} ><b>{d.timeago}</b></span>{"  "}<ArticleLink data={d} quoteswitch={quoteswitch} /></span><NewsSaveButton data={d} source={name} buttonStyle={{ marginLeft: 10 }} /></p>
                    )) :
                    <p class="marginItem" style={{ marginBottom: "0" }}>Updating...</p>
                  }
                </div>
                <div style={{ backgroundColor: theme === 'dark' ? "#002147" : "#F7F9F9", maxWidth: 350, borderBottomLeftRadius: "20px 20px", borderBottomRightRadius: "20px 20px", padding: 10 }}>
                  {news.length > 2 ?
                    <Button id={identifierButton + "t"} style={{ marginLeft: 6, marginTop: 5, borderRadius: 20 }} onClick={makeScrollableForText} variant="contained">
                      {activeScroll ? "See Less" : "See More"}
                    </Button> :
                    <></>
                  }
                </div>
              </>
          }
        </Swiper>
        {linkspreview && linkspreview.length !== 0 ?
          <Button id={identifierButton} style={{ marginLeft: 6, marginTop: 10, borderRadius: 20 }} onClick={makeScrollable} variant="contained">
            See More
          </Button> :
          <></>
        }
      </div>
    );
  }
  else if (effectiveLayout === 2) {
    return (
      <>
        {/* Layout 2 is the expanded news list, which a theme card does reach
            via makeScrollable ("See More"), so the icon has to be suppressed
            here too. */}
        <h3 style={{ maxWidth: 350, borderTopLeftRadius: 20, borderTopRightRadius: 20, margin: 0 }} class="p-3 bg-primary bg-gradient text-white draggable"><CardTitle name={name} website={website} kind={kind} /> <Logo name={name} kind={kind} />{isTheme ? <></> : <InfoIcon onClick={e => handleLayoutChange(e)} className="notDraggable" style={{ float: "right", marginTop: 5, cursor: "pointer" }} />}</h3>
        <div id={identifier} style={{ backgroundColor: theme === 'dark' ? "#002147" : "#F7F9F9", maxHeight: 500, maxWidth: 350, overflowX: "hidden", overflowY: "auto", paddingLeft: 8 }} class="itemHeightMobil">
          <small style={{ display: "none" }}>{id}</small>
          {news.length !== 0 ?
            news.map((d) => (
              <p class="marginItem" style={{ marginBottom: 5, marginTop: 5, marginRight: 8, display: "flex", alignItems: "center" }}><span style={{ flex: 1, minWidth: 0 }}><span class="bg-primary bg-gradient text-white" style={{ padding: 2, borderRadius: 5 }} ><b>{d.timeago}</b></span>{"  "}<ArticleLink data={d} quoteswitch={quoteswitch} /></span><NewsSaveButton data={d} source={name} buttonStyle={{ marginLeft: 10 }} /></p>
            )) :
            <p class="marginItem" style={{ marginBottom: "0" }}>Updating...</p>
          }
        </div>
        <div style={{ backgroundColor: theme === 'dark' ? "#002147" : "#F7F9F9", maxWidth: 350, borderBottomLeftRadius: "20px 20px", borderBottomRightRadius: "20px 20px", padding: 10 }}>
          <Button id={identifierButton} style={{ marginLeft: 6, marginTop: 5, borderRadius: 20 }} onClick={makeScrollable} variant="contained">
            See Less
          </Button>
        </div>
      </>
    );
  } else if (effectiveLayout === 3) {
    return (
      <>
        <h3 style={{ maxHeight: 250, maxWidth: 350, borderRadius: 20 }} class="p-3 mb-2 bg-primary bg-gradient text-white"><CardTitle name={name} website={website} kind={kind} /> <Logo name={name} kind={kind} /><InfoIcon onClick={e => handleLayoutChange(e)} style={{ float: "right", marginTop: 5, cursor: "pointer" }} /></h3>
        <div style={{ maxHeight: 250, maxWidth: 350, overflowX: "hidden", overflowY: "auto", marginLeft: 8 }}>
          <small style={{ display: "none" }}>{id}</small>
          <p class="marginItem">{description}</p>
        </div>
      </>
    );
  } else if (effectiveLayout === 4) {
    return (
      <>
        <h3 style={{ maxWidth: 350, borderRadius: 20 }} class="p-3 mb-2 bg-primary bg-gradient text-white"><CardTitle name={name} website={website} kind={kind} /> <Logo name={name} kind={kind} /><InfoIcon onClick={e => handleLayoutChange(e)} style={{ float: "right", marginTop: 5, cursor: "pointer" }} /></h3>
        <div id={identifier} style={{ backgroundColor: theme === 'dark' ? "#0D1F2D" : "#F7F9F9", borderRadius: 8, maxHeight: 250, maxWidth: 345, overflowX: "hidden", overflowY: "hidden", marginLeft: 5 }} class="itemHeightMobil">
          <small style={{ display: "none" }}>{id}</small>
          <Image name={name} setLayout={setLayout} theme={theme} />
        </div>
      </>
    );
  }

}

// Carousel slide image for SocialMediaNewsPreview. Fixed height + cover so
// fade slides don't resize between images or before load; falls back to
// /newspaper.jpg on error or missing src. Clicking the left half of the image
// goes to the previous slide, the right half to the next (replaces the
// navigation arrows).
const PreviewSlideImage = ({ src, fallback, alt }) => {
  const [error, setError] = useState(false);
  const swiper = useSwiper();
  return (
    <img
      loading="lazy"
      alt={alt || ""}
      src={error || !src ? fallback : src}
      style={{ width: "100%", height: 200, objectFit: "cover", display: "block", cursor: "pointer" }}
      onError={(e) => { e.preventDefault(); setError(true); }}
      onClick={(e) => {
        // allowClick is false when the click ends a touch-swipe; don't double-navigate.
        if (!swiper || !swiper.allowClick) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        if (x < rect.width / 2) swiper.slidePrev(); else swiper.slideNext();
      }}
    />
  );
}

export const setDefaultImage = (imgId, socialmedia, theme) => {
  var defaultImage;
  var windowSize = window.innerWidth;
  if (windowSize <= 320) {
    defaultImage = "/" + socialmedia.toString().toLowerCase() + "-image" + "-" + theme + "320" + ".png";
  } else {
    defaultImage = "/" + socialmedia.toString().toLowerCase() + "-image" + "-" + theme + ".png";
  }
  document.getElementById(imgId).src = defaultImage;
}

export const DefaultImage = (socialmedia, theme) => {
  var defaultImage;
  var windowSize = window.innerWidth;
  if (windowSize <= 320) {
    defaultImage = "/" + socialmedia.toString().toLowerCase() + "-image" + "-" + theme + "320" + ".png";
  } else {
    defaultImage = "/" + socialmedia.toString().toLowerCase() + "-image" + "-" + theme + ".png";
  }
  return defaultImage;
}

export const Breach = (props) => {
  const breach = props.data;

  return (
    <>
      <h3 style={{ maxHeight: 250, maxWidth: 350, borderRadius: 20 }} class="p-3 mb-2 bg-primary bg-gradient text-white"><a target="_blank" className="white" style={{ color: "#fff", textDecoration: "none" }} href={breach.domain}>{breach.name}</a></h3>
      <div style={{ maxHeight: 250, maxWidth: 350, overflowX: "hidden", overflowY: "auto", marginLeft: 8 }}>
        <p class="marginItem" style={{ marginBottom: "0" }}>{Parser(breach.description)}</p>
      </div>
    </>
  );
}

// The title in a social-news card header, shared by all 7 card layouts in
// SocialMediaNews/SocialMediaNewsPreview. All 20 platform cards carry a
// non-null website and keep exactly the link markup they always had; a
// user-created THEME card has website === null and takes the truncating
// branch below instead of an <a> that navigates nowhere.
const CardTitle = ({ name, website, kind }) => {
  if (kind === "THEME") {
    // A theme title is user-entered (1-40 characters) and the h3 font size is
    // responsive (Bootstrap h3 is calc(1.3rem + .6vw)), so it is truncated
    // with a CSS ellipsis rather than a character count, which would be wrong
    // at some widths. The title takes the remaining width (flex 1 plus
    // minWidth 0 - without minWidth 0 a flex child refuses to shrink below its
    // content and the ellipsis never triggers) while PersonIcon keeps its
    // natural size (flexShrink 0). PersonIcon marks the card as the user's own
    // and sits inline right after the title, in the slot where a platform card
    // shows its Logo - Logo renders nothing for a theme. It deliberately gets
    // no notDraggable class: it is decorative with no handler, and the theme
    // header is meant to stay grabbable end to end.
    return (
      <span style={{ display: "flex", alignItems: "center" }}>
        <span className="white" style={{ color: "#fff", textDecoration: "none", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>
        <PersonIcon style={{ flexShrink: 0, marginLeft: 6 }} />
      </span>
    );
  }
  if (!website) {
    return <span className="white" style={{ color: "#fff", textDecoration: "none" }}>{name}</span>;
  }
  return <a target="_blank" className="white" style={{ color: "#fff", textDecoration: "none" }} href={website}>{name}</a>;
}

export const Logo = ({ name, kind }) => {
  // A user-created theme card deliberately gets no icon at all - not a
  // generic one, not a substitute. Only the 20 built-in platforms have logos.
  // The default branch below would already return nothing for an unmatched
  // title, but this makes the intent explicit and guarantees a theme title can
  // never fall into a platform case (the backend reserves the 20 names
  // case-insensitively, so this is defence in depth).
  if (kind === "THEME") {
    return <></>;
  }
  switch (name) {
    case "Twitter":
      return <XIcon />;
    case "Facebook":
      return <FacebookIcon />;
    case "Instagram":
      return <InstagramIcon />;
    case "YouTube":
      return <YouTubeIcon />;
    case "WhatsApp":
      return <WhatsAppIcon />;
    case "Github":
      return <GitHubIcon />;
    case "Reddit":
      return <RedditIcon />;
    case "Linkedin":
      return <LinkedInIcon />;
    case "Telegram":
      return <TelegramIcon />;
    case "Xing":
      return <img alt="xing-logo" src="/xing-logo.png" />;
    case "Wechat":
      return <img alt="wechat-logo" src="/wechat-logo.png" />;
    case "Vkontakte":
      return <img alt="vk-logo" src="/vk-logo.png" />;
    case "Pinterest":
      return <PinterestIcon />;
    case "Discord":
      return <img alt="discord-logo" src="/discord-logo.png" />;
    case "Tinder":
      return <img alt="tinder-logo" src="/tinder-logo.png" />;
    case "Signal":
      return <img alt="signal-logo" src="/signal-logo.png" />;
    case "Snapchat":
      return <img alt="snapchat-logo" src="/snapchat-logo.png" />;
    case "TikTok":
      return <img alt="tiktok-logo" src="/tiktok-logo.png" />;
    case "Twitch":
      return <img alt="twitch-logo" src="/twitch-logo.png" />;
    case "Patreon":
      return <img alt="patreon-logo" src="/patreon-logo.png" />;
    case "Onlyfans":
      return <><img alt="onlyfans-logo" src="/onlyfans-logo.png" /> <img alt="18-logo" src="/18.png" /></>;
    default:
      return <></>;
  }
}

const Image = ({ name, setLayout, theme }) => {
  var windowSize = window.innerWidth;
  var imageLocation;
  var tmpName;
  if (windowSize <= 320) {
    if (name === "Twitter")
      tmpName = "X-Twitter";
    else
      tmpName = name;
    imageLocation = "/" + tmpName.toLowerCase() + "-image" + "-" + theme + "320" + ".png";
  } else {
    if (name === "Twitter")
      tmpName = "X-Twitter";
    else
      tmpName = name;
    imageLocation = "/" + tmpName.toLowerCase() + "-image" + "-" + theme + ".png";
  }

  switch (name) {
    case "Twitter":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="twitter-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="twitter-image-dark" src={imageLocation} />
    case "Facebook":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="facebook-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="facebook-image-dark" src={imageLocation} />
    case "Instagram":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="instagram-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="instagram-image-dark" src={imageLocation} />
    case "YouTube":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="youtube-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} alt="youtube-image-dark" src={imageLocation} />
    case "WhatsApp":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="whatsapp-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} alt="whatsapp-image-dark" src={imageLocation} />
    case "Github":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="github-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="github-image-dark" src={imageLocation} />
    case "Reddit":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="reddit-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="reddit-image-dark" src={imageLocation} />
    case "Linkedin":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="linkedin-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="linkedin-image-dark" src={imageLocation} />
    case "Telegram":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="telegram-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="telegram-image-dark" src={imageLocation} />
    case "Xing":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="xing-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="xing-image-dark" src={imageLocation} />
    case "Wechat":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="wechat-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="wechat-image-dark" src={imageLocation} />
    case "Vkontakte":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="vk-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="vk-image-dark" src={imageLocation} />
    case "Pinterest":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="pinterest-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="pinterest-image-dark" src={imageLocation} />
    case "Discord":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="discord-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="discord-image-dark" src={imageLocation} />
    case "Tinder":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="tinder-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="tinder-image-dark" src={imageLocation} />
    case "Signal":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="signal-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="signal-image-dark" src={imageLocation} />
    case "Snapchat":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="snapchat-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="snapchat-image-dark" src={imageLocation} />
    case "TikTok":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="tiktok-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="tiktok-image-dark" src={imageLocation} />
    case "Twitch":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="twitch-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="twitch-image-dark" src={imageLocation} />
    case "Patreon":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="patreon-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="patreon-image-dark" src={imageLocation} />
    case "Onlyfans":
      return theme === "light" ? <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="onlyfans-image" src={imageLocation} />
        : <img onClick={() => { setLayout(1) }} onTouchMove={() => { setLayout(1) }} onMouseOver={() => { setLayout(1) }} alt="onlyfans-image-dark" src={imageLocation} />
    default:
      return <></>;
  }
}

const useStyles = makeStyles(theme => ({
  paper: {
    overflow: 'hidden !important',
    width: 350,
    '@media (min-width: 600px) and (max-width: 800px)': {
      width: 500
    },

    '@media (min-width: 800px)': {
      width: 600
    }
  },
  customizedButton: {
    backgroundColor: '#007bff',
    color: '#fff',
    float: 'right',
  },
}));

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export const DraggableDialogForPreview = ({ open, handleCloseForPreview, url }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const changeUrl = () => {
    window.open(url)
  }

  const q = useSelector(state => state.quote.quote);
  const [quote, setQuote] = useState(q);
  var index = Math.floor(Math.random() * (quote.length + 1))
  const [loadingQuote, setLoadingQuote] = useState(false)
  const t = useSelector(state => state.themeswitch);
  const [theme, setTheme] = useState(t);

  useEffect(() => {
    setQuote(q)
  }, [q]);

  useEffect(() => {
    setTheme(t);
  }, [t])

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseForPreview}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        classes={{ paper: classes.paper }}
      >
        <DialogTitle style={{ cursor: 'move', color: theme === 'dark' ? '#fff' : '#000', background: theme === 'dark' ? '#0D1F2D' : '#fff' }} id="draggable-dialog-title">
          <span>Keep reading</span>
        </DialogTitle>
        <DialogContent style={{ padding: 0, overflow: 'hidden' }}>
          <DialogContentText style={{ backgroundColor: theme === 'dark' ? '#0D1F2D' : '#fff', color: theme === 'dark' ? '#fff' : '#000', marginBottom: 0 }}>
            {/*             <div style={{ position: "fixed", zIndex: "1 !important", top : 200, left : 50 }}>
              <img src="thumbs_up_512x512.jpg" />
            </div>  */}
            {/* <ThumbnailForOneLink url={url}/> */}
            <p style={{ marginLeft: 10, marginRight: 10, marginBottom: 0, textAlign: 'center' }}><b>Help us build our <a class="hover" target="_blank" href="https://twitter.com/OneLikeApp">Twitter</a>{", "}<a target="_blank" href="https://www.reddit.com/r/OneLike/">Reddit</a>{" and "}<a target="_blank" href="https://t.me/OnelikeApp">Telegram</a> Communities !</b></p><br />
            <p style={{ marginLeft: 10, marginRight: 10, marginBottom: 0, textAlign: 'center' }}>{quote[index] ? "\"" + quote[index].text + "\"" : ""}</p>
            <p style={{ marginLeft: 15, marginBottom: 0, paddingTop: 10 }}>{quote[index] ? quote[index].author : ""}</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ color: '#fff', background: theme === 'dark' ? '#0D1F2D' : '#fff' }} > {/* light */}
          <Button onClick={handleCloseForPreview} variant="contained">
            Close
          </Button>
          <Button onClick={changeUrl} variant="contained">
            Read the full Article
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

// Presentational row for a single Saved News entry. Extracted verbatim from
// SocialMediaListRender.js's SAVED_NEWS_NR .map(...) body so
// CustomSavedNewsPagination can render a page slice through the same markup
// - pure refactor, no behavior change.
export const SavedNewsRow = ({ item, theme, pinCounts, onUnsave }) => {
  return (
    <div style={{ backgroundColor: theme === 'dark' ? "#002147" : "#F7F9F9", borderRadius: 20, padding: 10, marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', maxWidth: 600 }}>
      <div style={{ marginRight: 20 }}>
        <span class="bg-primary bg-gradient text-white" style={{ padding: 2, borderRadius: 5, marginRight: 5 }}><b>{item.source}</b></span>
        <a target="_blank" rel="noreferrer" style={{ color: theme === 'dark' ? '#fff' : '#000', textDecoration: "underline dotted" }} href={item.url}>{item.title}</a>
      </div>
      <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
        <IconButton title={"Remove from Saved"} size="medium" onClick={() => onUnsave(item)} style={{ padding: 6, marginLeft: 20, background: "#1976d2", color: "#fff", borderRadius: 12 }}>
          <PushPinIcon style={{ color: '#ff0000' }} fontSize="medium" />
          {pinCounts && pinCounts[item.url] > 0 ? <span style={{ padding: "0 5px", marginLeft: 4, borderRadius: 5, background: "#1976d2", color: "#fff", fontSize: 13, lineHeight: "18px", height: "18px", display: "inline-flex", alignItems: "center" }}><b>{pinCounts[item.url]}</b></span> : null}
        </IconButton>
      </div>
    </div>
  );
}

export const DraggableDialogForConfirmUnsave = ({ open, handleClose, handleConfirm }) => {
  const t = useSelector(state => state.themeswitch);
  const [theme, setTheme] = useState(t);
  const classes = useStyles();

  useEffect(() => {
    setTheme(t);
  }, [t])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      classes={{ paper: classes.paper }}
    >
      <DialogTitle style={{ cursor: 'move', color: theme === 'dark' ? '#fff' : '#000', background: theme === 'dark' ? '#0D1F2D' : '#fff' }} id="draggable-dialog-title">
        <span>Remove from Saved News</span>
      </DialogTitle>
      <DialogContent style={{ padding: 0, overflow: 'hidden' }}>
        <DialogContentText style={{ backgroundColor: theme === 'dark' ? '#0D1F2D' : '#fff', color: theme === 'dark' ? '#fff' : '#000', marginBottom: 0 }}>
          <p style={{ marginLeft: 10, marginRight: 10, marginTop: 10, marginBottom: 10, textAlign: 'center' }}>
            Remove this article from your saved news?
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ color: '#fff', background: theme === 'dark' ? '#0D1F2D' : '#fff' }}>
        <Button onClick={handleClose} variant="contained">
          Cancel
        </Button>
        <Button onClick={handleConfirm} variant="contained">
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const ThumbnailForOneLink = ({ title, url }) => {
  var width; var height;
  if (window.innerWidth < 600) {
    width = 350; height = 600;
  } else if (window.innerWidth >= 600 && window.innerWidth < 1200) {
    width = 500; height = 800;
  } else if (window.innerWidth >= 1200) {
    width = 600; height = 900;
  }

  const checkIfLoaded = () => {
    console.log('loaded')
    // console.log(document.getElementById('iframe'))
    /*     try {
          console.log(document.getElementById('iframe').contentWindow.document)
        } catch (error) {
          $('#iframe').remove();
        } */

    // console.log(document.getElementById('iframe').document)


    // console.log(document.getElementById('iframe').contentWindow.document)
    // console.log(!($('#iframe').contentDocument))
    // console.log(!($('#iframe').contentDocument.title))
    // console.log(title !== $('#iframe').contentDocument.title)
    // if(!($('#iframe').contentDocument) || !($('#iframe').contentDocument.title) || title !== $('#iframe').contentDocument.title){
    //   console.log('Conditions1')
    //   $('#iframe').remove();
    // }
  }

  return (
    <Thumbnail
      url={url}
      width={width}
      height={height}
      iframeHeight={1920}
      iframeWidth={1080}
      interactive={false}
      onLoad={checkIfLoaded}
    />
  );
}

export const NewsSaveButton = ({ data, source, size, buttonStyle }) => {
  const dispatch = useDispatch();
  const lin = useSelector((state) => state.authentication.loggedIn);
  const u = useSelector((state) => state.authentication.user);
  const authenticated = lin && u;

  // Pin state is read from the already-loaded savedNewsList (fetched once on
  // app load in Home.js, kept current on every pin/unpin via
  // newspin.reducer.js) instead of each button fetching it individually -
  // that was one GET /service/mypinnednews per rendered news item.
  const savedNewsList = useSelector((state) => state.newspin.savedNewsList);
  const onPinFromRedux = authenticated && data && data.url
    ? (savedNewsList || []).some(item => item.url === data.url)
    : false;

  // How many users (across everyone, not just this one) have pinned this
  // article - looked up from the bulk /pincount fetch (see newspin.reducer.js),
  // not a per-article request.
  const pinCounts = useSelector((state) => state.newspin.pinCounts);
  const pinCountFromRedux = data && data.url ? (pinCounts && pinCounts[data.url]) || 0 : 0;

  // Local optimistic state, flipped synchronously in handlePin before the
  // dispatch below - same pattern as Publisher.js's handlePin /
  // SpaceItem.js's setBalanceOnLumen, so the icon/count give instant
  // feedback instead of waiting on the pin POST + Redux round trip. No
  // rollback on failure, matching those precedents.
  const [onPin, setOnPin] = useState(onPinFromRedux);
  const [pinCount, setPinCount] = useState(pinCountFromRedux);

  // Reconcile with Redux once its derived values actually change (the pin
  // POST response landing, or savedNewsList/pinCounts changing from another
  // tab/mount-time fetch) - kept live via the dependency array rather than a
  // one-time mount effect, since these are shared, ever-changing reducers.
  useEffect(() => {
    setOnPin(onPinFromRedux);
  }, [onPinFromRedux]);

  useEffect(() => {
    setPinCount(pinCountFromRedux);
  }, [pinCountFromRedux]);

  const pinStyle = { color: onPin ? '#ff0000' : 'inherit' };

  // Shown to everyone now (marketing value - anonymous visitors can see the
  // feature and the count), but only authenticated users can actually pin.
  // A logged-out click opens the same sign-in popup used elsewhere in the
  // app instead of silently doing nothing.
  const [openSignInPopup, setOpenSignInPopup] = useState(false);

  const handlePin = () => {
    if (!authenticated) {
      setOpenSignInPopup(true);
      return;
    }
    if (data && data.url) {
      const nextPinned = !onPin;

      // Optimistic local update - instant feedback, no rollback on failure
      // (matches Publisher.js/SpaceItem.js precedent).
      setOnPin(nextPinned);
      setPinCount((prev) => nextPinned ? prev + 1 : (prev - 1 > 0 ? prev - 1 : 0));

      var pin = new NewsPinClass()
      pin.url = data.url;
      pin.title = data.title;
      pin.source = source;
      pin.timeago = data.timeago;
      pin.publishedat = data.publishedat;
      pin.pinned = nextPinned;
      pin.uuid = u.uuid;
      pin.firstname = u.firstname;
      pin.name = u.name;
      pin.email = u.email;
      pin.displayname = u.displayname;

      const replacer = (key, value) => {
        if (typeof value === 'undefined')
          return ""
        else return value;
      }
      var pinInfos = JSON.parse(JSON.stringify(pin, replacer));

      dispatch(newspinActions.pin(pinInfos))
    }
  }

  return (
    <>
      <IconButton title={"Save for later"} size={size || "small"} onClick={handlePin} style={{ padding: 2, marginLeft: 4, background: "#1976d2", color: "#fff", borderRadius: 5, verticalAlign: "middle", ...buttonStyle }}>
        <PushPinIcon style={pinStyle} fontSize={size || "inherit"} />
        {pinCount > 0 ? <span style={{ padding: "0 5px", marginLeft: 4, borderRadius: 5, background: "#1976d2", color: "#fff", fontSize: 13, lineHeight: "18px", height: "18px", display: "inline-flex", alignItems: "center" }}><b>{pinCount}</b></span> : null}
      </IconButton>
      {!authenticated ? <DraggableSignInPopup openSignInPopup={openSignInPopup} handleCloseSignInPopup={() => setOpenSignInPopup(false)} /> : null}
    </>
  );
}

const ArticleLink = ({ data, quoteswitch, previewswitch }) => {
  const [open, setOpen] = useState(false);
  const t = useSelector(state => state.themeswitch);
  const [theme, setTheme] = useState(t);



  const handleOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  }
  const handleCloseForPreview = () => {
    setOpen(false);
  }

  useEffect(() => {
    setTheme(t);
  }, [t])

  if (previewswitch) {
    if (quoteswitch) {
      return (
        <>
          <span
            className="white"
            style={{ color: '#fff', textDecoration: "underline dotted", cursor: "pointer" }}
            onClick={e => handleOpen(e)}
          >
            {data.title}
          </span>
          <DraggableDialogForPreview open={open} handleCloseForPreview={handleCloseForPreview} url={data.url} title={data.title} />
        </>
      );
    } else {
      return (
        <span
          className="white"
          style={{ color: '#fff', textDecoration: "underline dotted", cursor: "pointer" }}
          onClick={() => { window.open(data.url, "_blank"); }}
        >
          {data.title}
        </span>
      );
    }
  } else {
    if (quoteswitch) {
      return (
        <>
          <span
            className="hover"
            style={{ color: theme === 'dark' ? '#fff' : '#000', textDecoration: "underline dotted", cursor: "pointer" }}
            onClick={e => handleOpen(e)}
          >
            {data.title}
          </span>
          <DraggableDialogForPreview open={open} handleCloseForPreview={handleCloseForPreview} url={data.url} title={data.title} />
        </>
      );
    } else {
      return (
        <span
          className="hover"
          style={{ color: theme === 'dark' ? '#fff' : '#000', textDecoration: "underline dotted", cursor: "pointer" }}
          onClick={() => { window.open(data.url, "_blank"); }}
        >
          {data.title}
        </span>
      );
    }
  }


}

const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

{/*                   <>
                    {theme === "dark" && <img id={imgId} loading="lazy" alt="" src={error ? DefaultImage(name, theme) : loaded ? d.image : DefaultImage(name, theme)} onLoad={(e) => { e.preventDefault(); showImage(); }} onError={(e) => { e.preventDefault(); hasError(); }} />}
                    {theme === "light" && <img id={imgId} loading="lazy" alt="" src={error ? DefaultImage(name, theme) : loaded ? d.image : DefaultImage(name, theme)} onLoad={(e) => { e.preventDefault(); showImage(); }} onError={(e) => { e.preventDefault(); hasError(); }} />}
                  </> */}